import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { Button, Grid, Typography, withStyles } from '@material-ui/core'
import { ArrowForward, ArrowBack } from '@material-ui/icons'
import UserService from '../../services/UserService'
import notFound from './img/not-found.svg'
import styles from './PageNotFound.styles'

const signed = !!UserService.isLoggedIn()

const PageNotFound = ({ classes, history }) => {
  const handleClickPainel = () => history.push('/dashboard')

  return (
    <Grid container direction="row" justify="center" alignItems="center" className={classes.root}>
      <Grid item xs={12} lg={3}>
        <Typography variant="h3" className={classes.title}>
          Parece que a página que você tentou acessar não existe mais.
        </Typography>

        {signed ? (
          <>
            <Typography variant="h4" className={classes.subTitle}>
              Mas há muitas outras coisas que você pode fazer por aqui. Que tal ir para o painel
              inicial?
            </Typography>
            <Button variant="contained" className={classes.button} onClick={handleClickPainel}>
              Painel inicial
              <ArrowForward className={classes.iconButton} />
            </Button>
          </>
        ) : (
          <>
            <Typography variant="h4" className={classes.subTitle}>
              Mas há muitos outros conteúdos te esperando por aqui. Que tal conhecer mais sobre o
              Senna?
            </Typography>
            <Button variant="contained" className={classes.button} onClick={handleClickPainel}>
              <ArrowBack className={classes.iconBackButton} />
              Voltar
            </Button>
          </>
        )}
      </Grid>
      <Grid item xs={12} lg={3}>
        <img src={notFound} alt="Adicionar Estudante" className={classes.img} />
      </Grid>
    </Grid>
  )
}

PageNotFound.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
}

export default withStyles(styles)(withRouter(PageNotFound))
